module.exports = __webpack_public_path__ + "img/ico-check-18.c8785353.svg";